import * as XLSX from 'xlsx';

export const downloadSampleExtraChargesSheet = () => {
  const data = [
    ['Shipment Number', 'Charge Type', 'Charge Name', 'Value', 'Apply Global Charge', 'Apply Tax'],
    ['815849530000', 'Add', 'Demand Surcharge', 2000, 'Fuel Surcharge, Extra Charge', 'Yes'],
    ['815849530000', 'Discount', 'Demand Surcharge', 2000, '', 'No'],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Column widths
  worksheet['!cols'] = [{ wch: 20 }, { wch: 15 }, { wch: 25 }, { wch: 12 }, { wch: 30 }, { wch: 15 }];

  // Freeze Header Row
  worksheet['!freeze'] = {
    xSplit: 0,
    ySplit: 1,
  };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Extra Charges Upload');

  XLSX.writeFile(workbook, 'sample_bulk_extra_charges_upload.xlsx');
};
